import type { CityDto } from '@posilka/shared';
import { useTranslation } from 'react-i18next';
import { cityName } from '@posilka/client/lib/cities';

export function CitySelect({
  cities,
  value,
  onChange,
  exclude,
  placeholder,
}: {
  cities: CityDto[];
  value: string | undefined;
  onChange: (id: string) => void;
  exclude?: string;
  placeholder?: string;
}) {
  const { t, i18n } = useTranslation();
  const sorted = [...cities].sort((a, b) =>
    cityName(a, i18n.language).localeCompare(cityName(b, i18n.language), i18n.language),
  );
  return (
    <select className="input" value={value ?? ''} onChange={(e) => onChange(e.target.value)}>
      <option value="" disabled>
        {placeholder ?? t('order.chooseCity')}
      </option>
      {sorted.map((c) => (
        <option key={c.id} value={c.id} disabled={c.id === exclude}>
          {cityName(c, i18n.language)}
        </option>
      ))}
    </select>
  );
}
